module.exports = __webpack_public_path__ + "static/media/elevator.b0d9be6b.mp3";